import { TEXT_PLACEHOLDER } from '@/lib/layout/Header/utils';

const NUMBER_FORMAT = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export function formatCurrency(value: number | bigint) {
  return NUMBER_FORMAT.format(value);
}

export function formatCurrencyWithPlaceholder(
  value: number | bigint,
  placeholder: string = TEXT_PLACEHOLDER
) {
  if (value === 0) return placeholder;

  return formatCurrency(value);
}
